module.exports = __webpack_public_path__ + "media/images/pay2-color-bbf8e03603f31907fd475dcd04e727f8.svg";